import { useEffect, useMemo, useState, useSyncExternalStore } from 'react';
import { FenetreBeta, questionsDues, repondreBeta } from '../../app/beta.js';
import { creerClient, type Client } from '../../api/client.js';
import type { Ecran, QuestionBeta } from '../../api/contrat.js';
import { creerControleurAdmin } from './controleur.js';
import { PageAdministration } from './PageAdministration.js';

/**
 * Écran D10 branché sur la coquille : `REGISTRE` lit `ecrans` par `import.meta.glob`. La coquille ne passe pas
 * encore son client aux écrans (RFC-L59-001) : à défaut, l'écran crée le sien sur le `fetch` du navigateur.
 */
export function EcranAdministration({ ecran, client }: { ecran: Ecran; client?: Client }) {
  const [question, setQuestion] = useState<QuestionBeta | null>(null);
  const api = useMemo(() => client ?? creerClient({ fetch: (...appel) => globalThis.fetch(...appel) }), [client]);
  const ctl = useMemo(
    () =>
      creerControleurAdmin({
        client: api,
        recharger: () => globalThis.location.reload(),
        // Question BETA-26 posée au bon moment : juste après la création d'une étude (lot 4, point 8 b).
        apresCreationEtude: () => void questionsDues(api, 'D10.etude_creee').then((qs) => setQuestion(qs[0] ?? null)),
      }),
    [api],
  );
  const etat = useSyncExternalStore(ctl.subscribe, ctl.getEtat, ctl.getEtat);
  useEffect(() => {
    void ctl.charger();
  }, [ctl]);
  return (
    <>
      {question ? (
        <FenetreBeta
          question={question}
          onRepondre={(option) => {
            const q = question;
            setQuestion(null);
            void repondreBeta(api, q, option, 'D10').catch(() => undefined);
          }}
          onPlusTard={() => setQuestion(null)}
        />
      ) : null}
      <PageAdministration titre={ecran.titre} etat={etat} actions={{ ...ctl, charger: () => void ctl.charger() }} />
    </>
  );
}

export const ecrans = { D10: EcranAdministration } as const;
